import React, { useEffect, useState } from "react";
import CardStyle from "../../css/coupon.module.scss";
import axios from "../../config/authaxios";

import Dropdown from "../../css/dropdown.module.scss";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ThemeContext } from "../../context/ThemeProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, TextField, Typography,Stack,Box } from "@mui/material";
import Chip from "@material-ui/core/Chip";
import JoditEditor from "jodit-react";
import moment from "moment";
import CountrySelect from "../../ui/CountrySelect";
import { getCountryId } from "../../services/countries";



function Edit() {
  const search = useLocation().search;
  const navigate = useNavigate();
  const couponId = new URLSearchParams(search).get("couponId");



  const [coupons, setCoupons] = useState({});
  const [priceArray, setPriceArray] = useState([]);
  const [priceInput, setPriceInput] = useState([]);
  const [expiry, setExpiry] = useState();
  const [detailColorArray,setDetailColorArray]=useState(["#000","#000","#000"])
  const [pointArray, setPointArray] = useState([]);
  const [pointInput, setPointInput] = useState("");
  const [countryId, setCountryId] = useState("");

  const [image, setImage] = useState();
  //   const [page, setPage] = useState(0);
  //   const [limit, setLimit] = useState(10);
  //   const [isUsed, setIsUsed] = useState(false);
  //   const [isMore, setIsMore] = useState(false);
  //   const [load, setLoad] = useState(false);
  //   const [nodata, setNodata] = useState(false);
  const fetchCouponDetail = () => {
    axios.get(`/admin/ka-voucher/${couponId}`).then((res) => {
      //console.log("response-->", res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        setPriceArray(res.data.response.price.denominations);
        setImage(res.data.response.images.mobile);
        setExpiry(
          moment(res?.data?.response?.expiry).format("YYYY-MM-DDTHH:MM")
        );
        setDetailColorArray(
          res.data.response.detail_colors.length == 0
            ? ["#000", "#000", "#000"]
            : res.data.response.detail_colors
        );
        setPointArray(res.data.response.how_to_use_points);
        setCountryId(getCountryId(res.data.response?.country));

      }
    });
  };

  useEffect(() => {
    fetchCouponDetail();

    //   return () => {
    //     setCoupons()
    //   }
  }, []);
  const handlefileInput = (e) => {
    const Dataform = new FormData();
    Dataform.append("file", e.target.files[0]);
    let FileSize = Number(e.target.files[0].size / 1000);
    var file = e.target.files[0];
    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;
    img.onload = function () {
      // //console.log(img, file);
      width = this.width;
      height = this.height;
      // if (FileSize > 5000) {
      //     return alert(`Image should be to under 50kb reupload image, Your file size is ${FileSize}`)
      // }
      // if (height <= 250 && height > 150 && width <= 1352 && width > 450) {
      //console.log(Dataform);
      axios.post(`/admin/upload-image`, Dataform).then((res) => {
        //console.log(">>Image_url>>", res.data.Image.url);
        let data = res.data.Image.url;
        // setCoupons({ ...coupons,image: res.data.Image.url });
        setImage(data);
        //console.log("image-->", image)
      });
      alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
      // } else {
      //   alert(
      //     `Image height less then 250 & greater then 150 width less then 1352 & greater then 450, Your height=${height} & width=${width}`
      //   );
      // }
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  };
  const onChangeHandler = (e) => {
    //console.log("id-->", e.target.id, e.target.value);
    setCoupons({ ...coupons, [e.target.id]: e.target.value });
  };

  const AddPriceInArray = () => {
    let temp = priceArray;
    //console.log("push input", priceInput);
    temp.push(...priceInput);
    setPriceArray(temp);
    //console.log("price Array-->", priceArray)
    setPriceInput("");
  };

  const handleDeleteRule = (index) => {
    let temp = priceArray;
    temp.splice(index, 1);
    setPriceArray([...temp]);
  };

  const onChangeHandlerColor = (index, newColor) => {
    const updatedColors = [...detailColorArray];
    updatedColors[index] = newColor;
    setDetailColorArray(updatedColors);
    console.log(detailColorArray);
  };

  const updateHandler = () => {
    let obj = {...coupons};
    obj.voucherId = couponId;
    obj.name = coupons.name;
    obj.description = coupons.description
    obj.description = coupons.how_to_use_desc
    obj.how_to_use_points = pointArray
    obj.detail_colors = detailColorArray
    obj.image = image;
    obj.price = priceArray;
    // obj.expiry = moment(expiry).format("YYYY-MM-DDTHH:MM:sssZ");
    obj.expiry = moment(expiry).format('YYYY-MM-DD[T00:00:00.000Z]');
    obj.country = countryId;
    //console.log("obj---->", obj);
    axios.put(`/admin/ka-voucher`, obj).then((res) => {
      //console.log(res);
      // let data = res.data.response;
      alert(res.data.message);
      navigate("/kacouponlist");
    });
  };

  const handleDeletePoint = (index) => {
    let temp = pointArray;
    temp.splice(index, 1);
    setPointInput([...temp]);
  };

  const AddPointInArray = () => {
    let temp = pointArray;
    temp.push(...pointInput);
    setPointArray(temp);
    setPointInput("");
  };

  return (

    <>
      <Card sx={{ p: 4 }}>

      <section
        style={{
          display: "flex",
          alignItems: "space-between",
          justifyContent: "space-between",
          border: "2px solid black",
          padding:"10px",
          gap:"20px"
        }}
      >

          


        <section style={{ width: "45%",display:"flex",flexDirection:"column",gap:"20px" }}>
          <section style={{padding:"10px"}}>
            <Typography> Name :</Typography>
            <TextField
              type="text"
              className="rounded  py-2"
              id="name"
              value={coupons.name}
              onChange={onChangeHandler}
            // placeholder="Enter App version"
            />
          </section>
          <section style={{ maxWidth: "600px",padding:"10px" }}>
            <Typography>Description :</Typography>
            {/* <textarea rows="10" cols="30"
              type="text"
              className="rounded  py-2"
              id="description"
              value={coupons.description}
              onChange={onChangeHandler}
            /> */}
            {/* <JoditEditor
              
              tabIndex={5}
              id="description"
              value={coupons.description}
              onBlur={(e)=>{ setCoupons({...coupons,description:e})}}
              onChange={(e)=>{ setCoupons({...coupons,description:e})}}
            /> */}
            <ReactQuill theme="snow" value={coupons.description} onChange={(e) => { setCoupons({ ...coupons, description: e }) }} />
          </section>

          <section>
            <Typography>Image :</Typography>
            {image ? (
              <button
                onClick={() => {
                  setImage("");
                }}
              >
                Re-Upload
              </button>
            ) : (
              <TextField
                type="file"
                // className="rounded  py-2"
                id="image"
                onChange={handlefileInput}
                placeholder="Select Image"
                accept="image/*"
              />
            )}
            {/* <TextField
              type="text"
              className="rounded  py-2"
              id="image"
              value={image}
              onChange={(e) => {
                setImage(e.target.value);
              }} */}
            {/* /> */}

            <Stack spacing={1}>
            <Typography> Price :</Typography>
            <TextField
              fullWidth
              type="number"
              className="rounded  py-2"
              onKeyDown={(evt) =>
                ["e", "E", "+", "-", " "].includes(evt.key) &&
                evt.preventDefault()
              }
              id="price"
              value={priceInput}
              onChange={(e) => {
                e.target.value > 0
                  ? setPriceInput([e.target.value])
                  : setPriceInput();
              }}
            />
            <Box>
              <Button
                variant="contained"
                color="info"
                disabled={priceInput ? false : true}
                onClick={AddPriceInArray}
              >
                {priceInput ? "Add Price" : "Enter Price"}
              </Button>
            </Box>
          </Stack>
          <section>
            {priceArray.length > 0 &&
              priceArray.map((item, index) => {
                return (
                  <Chip
                    key={index}
                    onDelete={() => {
                      handleDeleteRule(index);
                    }}
                    label={item}
                  />
                );
              })}
          </section>

          <section>
            <Typography> Partner Link :</Typography>
            <TextField
              fullWidth
              type="text"
              className="rounded  py-2"
              id="partner_link"
              value={coupons.partner_link}
              onChange={onChangeHandler}
              // placeholder="Enter App version"
            />
          </section>

          <section>
            <Typography> Percentage :</Typography>
            <TextField
              fullWidth
              type="text"
              className="rounded  py-2"
              id="c_percentage"
              value={coupons.c_percentage}
              onChange={onChangeHandler}
              // placeholder="Enter App version"
            />
          </section>
          </section>
        </section>
        <section style={{ width: "45%",display:"flex",flexDirection:"column",gap:"20px" }}>
          <section style={{padding:"10px"}}>
            <Typography>Country :</Typography>
            <CountrySelect value={countryId} onChange={setCountryId} />
          </section>
          <section style={{padding:"10px"}}>
            <Typography> Expiry :</Typography>
            {/* {console.log("expiry", expiry)} */}
            <TextField
              type="datetime-local"
              className="rounded  py-2"
              id="expiry"
              value={expiry}
              onChange={(e) => {
                setExpiry(e.target.value);
              }}
            />
          </section>
        

          <section style={{ maxWidth: "600px",padding:"10px" }}>
            <Typography>how_to_use_desc :</Typography>
           
            <ReactQuill theme="snow" value={coupons.how_to_use_desc} onChange={(e) => { setCoupons({ ...coupons, how_to_use_desc: e }) }} />
          </section>


          <section style={{ maxWidth: "600px",padding:"10px" }}>
            <Typography>Brand description :</Typography>
           
            <ReactQuill theme="snow" value={coupons.brand_desc} onChange={(e) => { setCoupons({ ...coupons, brand_desc: e }) }} />
          </section>


          <Stack spacing={1}>
            <Typography> How to use points :</Typography>
            <TextField
              fullWidth
              type="text"
              className="rounded  py-2"
              // onKeyDown={(evt) => ["e", "E", "+", "-", " "].includes(evt.key) && evt.preventDefault()}
              id="price"
              value={pointInput}
              onChange={(e) => {
                setPointInput([e.target.value]);
              }}
            />
            <Box>
              <Button
                variant="contained"
                color="info"
                disabled={pointInput ? false : true}
                onClick={AddPointInArray}
              >
                {pointInput ? "Add Point" : "Enter Point"}
              </Button>
            </Box>
          </Stack>
          <section>
            {pointArray.length > 0 &&
              pointArray.map((item, index) => {
                return (
                  <Chip
                    key={index}
                    onDelete={() => {
                      handleDeletePoint(index);
                    }}
                    label={item}
                  />
                );
              })}
          </section>
          
          <section>
            <Typography> Outer Color :</Typography>
            <TextField
              type="color"
              className="rounded  py-2"
              style={{ width: "100px" }}
              id="outer_color"
              value={coupons.outer_color}
              onChange={onChangeHandler}

              // onClick={closeHandler}s
              // placeholder="Enter App version"
            />
          </section>


          <section style={{ display: "flex", flexDirection: "column" }}>
            <Typography> Detail color :</Typography>

            <div>
              {/* {JSON.stringify(detailColorArray)} */}
              {detailColorArray.map((color, index) => (
                <TextField
                  key={index}
                  type="color"
                  className="rounded py-2"
                  id={`detail_color${index}`}
                  xw
                  // value={color}
                  value={color}
                  onChange={(e) => onChangeHandlerColor(index, e.target.value)}
                  style={{ width: "100px", margin: "10px" }}
                />
              ))}
            </div>
          </section>
        </section>
      </section>
      <button style={{marginTop:"10px",background:"green",width:"80px",padding:"10px"}}onClick={updateHandler}>Update</button>
      </Card>
    </>
  );
}

export default Edit;
